// extracted by mini-css-extract-plugin
export var compactFilters = "_dg-4";
export var detailImage = "_dg-1";
export var dropdownContainer = "_dg-2";
export var imageContainer = "_dg-0";
export var selectedCard = "_dg-3";